import { ResourceModel } from './resource.model';
import { ResourceType } from '../../helpers/Const';

export class OrganizationModel extends ResourceModel {
    project: string;
    costObject: string;

    constructor(init?: Partial<OrganizationModel>) {
        super();
        Object.assign(this, init);
        this.type = ResourceType.ORGANIZATION;
    }
}
